import React from "react";
import ct from "class-types.macro";
import { Image } from "@wss/image";
import CommonCarousel, { Item } from "~/common/Carousel";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { CarouselOptions } from "./props";
const Carousel = (config: CarouselOptions) => {
  const additionalContainerClasses = (template => {
    switch (template) {
      case "Default Template":
        return ["default-template-grid", "grid-module"];
      default:
        return [];
    }
  })(config.template);
  const containerClassList = ["lt:mr-[2%] carousel--flex-container", ...additionalContainerClasses].join(" ");
  const width = config.useAlternateLayout ? {
    width: "13.75rem"
  } : {
    width: "11.25rem"
  };
  return <div className={containerClassList} data-testId={config.testId} data-sentry-component="Carousel" data-sentry-source-file="Carousel.tsx">
      {config.name && <h2 className={ct("font-semibold", "text-xl", "leading-tight", "mb-1")}>
          {config.name}
        </h2>}

      <CommonCarousel colorVariant={config.backgroundColor} data-sentry-element="CommonCarousel" data-sentry-source-file="Carousel.tsx">
        {config.sections.map(section => <Item classNames={ct("p-0", "text-center")} colorVariant={config.useAlternateLayout ? "navy" : config.backgroundColor} sliderRight key={section.imagePath} customInlineStyle={width}>
            <InnerSection bgColor={config.backgroundColor} link={section.link} description={section.description} imagePath={section.imagePath} showDescription={config.showDescriptions ?? true} useAlternateLayout={config.useAlternateLayout} />
          </Item>)}
      </CommonCarousel>
    </div>;
};
interface InnerSectionProps {
  bgColor: "gray" | "white" | "navy";
  link: string;
  description: string;
  imagePath: string;
  showDescription: boolean;
  useAlternateLayout?: boolean;
}
function InnerSection({
  bgColor,
  link,
  description,
  imagePath,
  showDescription,
  useAlternateLayout
}: InnerSectionProps) {
  const bgClass = bgColor === "gray" ? ct("bg-gray-100") : ct("bg-white");
  if (useAlternateLayout) {
    return <>
        <a className={ct("group", "bg-white", "rounded", "inline-block", "flex", "flex-col", "mx-2", "overflow-hidden", "pb-0")} href={link}>
          <Image alt={description} src={imagePath} className="flex-grow group-hover:opacity-90 w-full h-auto" data-testId="CarouselImage" height={50} width={69} />
          {showDescription && <h3 className={ct("bg-white", "box-border", "font-semibold", "text-sm", "leading-none", "mb-0", "p-2", "relative", "text-gray-800", "group-hover:text-green-400", "truncate", "w-full", "ease-in", "duration-200")}>
              {description}
            </h3>}
        </a>
      </>;
  }
  return <>
      <div className={ct("mx-2", "mt-2", bgClass)}>
        <a className={ct("border-transparent", "group-hover:border-gray-200", "border-solid", "border", "inline-block", "p-1")} href={link}>
          <NoScriptLazyImage alt={description} src={imagePath} height={140} width={140} dataTestId="CarouselImage" data-sentry-element="NoScriptLazyImage" data-sentry-source-file="Carousel.tsx" />
        </a>
      </div>
      {showDescription && <a href={link}>
          <h3 className={`carousel__card-title ${ct("text-green-500")}`}>
            {description}
          </h3>
        </a>}
    </>;
}
export default Carousel;